import React from "react";
import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import * as styles from "./background.module.less";

const variantMap = {
    bg_a: styles.backgroundVariantA,
    bg_b: styles.backgroundVariantB,
    bg_c: styles.backgroundVariantC,
    bg_d: styles.backgroundVariantD,
    bg_e: styles.backgroundVariantE,
    bg_f: styles.backgroundVariantF,
    bg_z: styles.backgroundVariantZ,
    bg_white: styles.backgroundVariantWhite,
    bg_grey: styles.backgroundVariantGrey
};

export function isLightBackground(value) {
    return ["bg_white", "bg_grey"].includes(value);
}

export function Background({ type = "bg_white", className, ...others }) {
    return (
        <div
            className={gcs(
                className,
                styles.background,
                variantMap[type] || ""
            )}
            {...others}
        />
    );
}
